import { useState, useEffect } from 'react';
import { Flex, TextArea, Button } from './shared';
import { theme } from '../design-system';
import { useAppointment } from '../../../context/appointmentContext';
import { client } from '../../../helpers/api-client';
import { keyframes } from '@emotion/react';
import { useMediaQuery } from '../../../helpers/useMediaQuery';

const enterFromTop = keyframes`
from {
  transform: translateY(calc(-100vw))
}

to {
  transform: translateY(0)
}`;

const FloatingNotes = ({ hideNotes }) => {
  const [localNotes, setLocalNotes] = useState('Loading notes...');
  const smallScreen = useMediaQuery('(max-width: 700px)');
  const {
    appointment: { currentAppointment },
  } = useAppointment();

  useEffect(() => {
    const getServerNotes = async () => {
      const { notes } = await client(`api/appointments/${currentAppointment.id}/`);
      setLocalNotes(notes || '');
    };

    getServerNotes();
  }, [currentAppointment]);

  const saveNotes = () => {
    client(`api/appointments/${currentAppointment.id}/`, { body: { notes: localNotes } }, 'PATCH').then(
      () => {
        return hideNotes();
      },
      (error) => {
        console.error('Error: ', error);
      },
    );

    return hideNotes();
  };

  return (
    <Flex
      column
      centered
      height='calc(100vh - 55px)'
      width='100vw'
      position='fixed'
      top='55px'
      animation={`${enterFromTop} 200ms forwards`}
      backgroundColor='white'
      left='0'
      zIndex='100'
      overflow='hidden'
    >
      <Flex column centered padding='2rem'>
        <TextArea
          style={{ border: '1px solid #c1c1c1', width: !smallScreen && '70vw', height: !smallScreen && '50vh' }}
          value={localNotes}
          onChange={(e) => setLocalNotes(e.target.value)}
          marginBottom='1.5rem'
        />
        <Flex>
          <Button
            padding={smallScreen ? '0.5rem' : '1rem'}
            marginRight='1rem'
            onClick={() => {
              saveNotes();
            }}
          >
            {`Save`}
          </Button>
          <Button
            padding={smallScreen ? '0.5rem' : '1rem'}
            backgroundColor={theme.colors.negativeDark}
            onClick={() => {
              hideNotes();
            }}
          >
            {`Cancel`}
          </Button>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default FloatingNotes;
